import SvgIcon from '@mui/material/SvgIcon';
import React, { memo } from 'react';

import { petrol } from '../../styles/mui/colors';

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.JSX.Element}
 */
const IconMenuComponent = ({ color = petrol.main, ...rest }) => {
  return (
    <SvgIcon sx={{ color }} {...rest} strokeWidth={1.5}>
      <svg
        className="size-6"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
};

IconMenuComponent.displayName = 'IconMenu';

const IconMenu = memo(IconMenuComponent);

export default IconMenu;
